import { render, staticRenderFns } from "./EntityAccessTypeTicketIcon.vue?vue&type=template&id=ac1cfaac&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports